module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("\n    Table of Contents\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_fm1_r1"
    }
  }, [_vm._v("Praise")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_fm2_r1"
    }
  }, [_vm._v("ALSO BY DAVID RHODES")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_tp_r1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_ded_r1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_ack_r1"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_fm3_r1"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c01_r1"
    }
  }, [_vm._v("NO REASON")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c02_r1"
    }
  }, [_vm._v("A NATION OF FAMILIES")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c03_r1"
    }
  }, [_vm._v("SCHEDULED VIOLENCE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c04_r1"
    }
  }, [_vm._v("MOTTLED SUNLIGHT")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c05_r1"
    }
  }, [_vm._v("GRIEF")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c06_r1"
    }
  }, [_vm._v("PAINTED BODIES AND ORANGE FIRES")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GATHERING EVIDENCE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THINK LESS, DO MORE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROTECTING PAPERS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KEEPING A RESPECTFUL DISTANCE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HUMPED FLOORS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A ROOM WITHOUT FURNITURE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FAITH KEEPS NO TREASURE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c14_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BROKEN THINGS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c15_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOT MILK")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c16_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HIRING HELP")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c17_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PERPETUAL PERISHING")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c18_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPIPHANY")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c19_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THEFT")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c20_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VISITOR")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c21_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STRAIGHT FLUSH")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c22_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TESTIMONY")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c23_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A PRIVATE HEAVEN")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c24_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WORK BEGINS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c25_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LETTER TO THE EDITOR")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c26_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIRE IN THE FIELD")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c27_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A NEW SONG")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c28_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FINISHING UP")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c29_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SNOW")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c30_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REMEMBERED LOVE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c31_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DESPERATION")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c32_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMPLETING THE CIRCLE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c33_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FAMILY")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c34_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENVY")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c35_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEEKING HELP")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c36_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THEODYSSEY")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c37_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEAR")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c38_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REUNION")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c39_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DON’T GO THAT WAY")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c40_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEASURING UP")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c41_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE MEANING OF TRUTH")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c42_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A FRAGILE BALANCE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c43_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INSURGENCY")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c44_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SLAUGHTER")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c45_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGHTING DOGS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c46_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE THIEF")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c47_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE UNIVERSAL ACORN")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c48_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HUNTING")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c49_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SPRING")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c50_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NEW LOVE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c51_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KEEPING IN ONE’S PLACE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c52_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MUSHROOMS ARE UP")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c53_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAKING BAIL")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c54_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE HEARTLAND FEDERAL RESERVE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c55_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INSIDE THE NEIGHBOR’S HOUSE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c56_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TRAPPED BY THE PAST")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c57_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VALUE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c58_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LETTING GO")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c59_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LAWYERS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c60_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RESEMBLANCE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c61_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE COUNTY FAIR")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c62_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAKING OTHER ARRANGEMENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c63_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEETING AT SNOW CORNERS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c64_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE LOOK OF DEATH")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c65_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FINDING JULY")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c66_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SELLING LAND")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c67_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INSIDE THE CHURCH")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c68_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE FUNERAL")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_c69_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DRIFTLESS")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_bm1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("READING GUIDE QUESTIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_bm2_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Q & A WITH DAVID RHODES")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_bm6_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE MILKWEED EDITIONS EDITOR’S CIRCLE")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/davi_9781571318008_oeb_cop_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d964771","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/davi_9781571318008_oeb_toc_r1.vue
// module id = 60
// module chunks = 0